import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
export const StyledHeader = styled('header', {
    shouldForwardProp: prop => isPropValid(prop),
})(({ theme, position }) => ({
    width: '100%',
    height: 'auto',
    minHeight: 'var(--cb-header-height)',
    top: 0,
    zIndex: 'var(--cb-z-index-header)',
    ...(typeof position === 'string' && {
        position,
    }),
    ...(typeof position === 'object' && {
        position: position.xs || 'static',
        ...['xs', 'sm', 'md', 'lg', 'xl'].reduce((styles, breakpoint) => {
            if (!position[breakpoint])
                return styles;
            if (breakpoint === 'xs')
                return styles;
            return {
                ...styles,
                [theme.breakpoint.minWidth(breakpoint)]: {
                    position: position[breakpoint],
                },
            };
        }, {}),
    }),
}));
export const StyledHeaderInner = styled.div `
  width: 100%;
  height: var(--cb-header-height-inner);
  background: ${({ theme }) => theme.color.background.primary};
`;
export const AssortmentLink = styled.a `
  height: 4.4rem;
  line-height: 4.4rem;
`;
//# sourceMappingURL=Header.styled.js.map